import React from "react";
import spinner from '../Assets/LoadingImg.gif'

function Loading(){
    return<div>
        <img id="centerModel" src={spinner} alt="spinner"></img>
    </div>
}

export default Loading;